import { useCollaborationStore } from '~/composables/useCollaborationStore';

type ActivityUserTooltipOptions = {
  userNm?: string;
  userDept?: string;
  userRank?: string;
};

/** 활동 탭 사용자 hover 툴팁 — 부서 경로 · 이름 직급 */
export const getActivityUserTooltipLines = (
  userId?: string,
  options: ActivityUserTooltipOptions = {},
) => {
  const { userList } = useCollaborationStore();
  const user =
    userId && userList.value?.length
      ? (userList.value as Record<string, unknown>[]).find(u => String(u.userId) === String(userId))
      : null;

  const deptLine = String(
    user?.deptFullNm ?? user?.deptFNm ?? user?.userDeptNm ?? options.userDept ?? user?.deptNm ?? '',
  ).trim();

  const name = String(options.userNm ?? user?.userNm ?? '').trim();
  const rank = String(
    user?.jikgubNm ?? user?.posNm ?? user?.jikwiNm ?? options.userRank ?? '',
  ).trim();
  const nameLine = [name, rank].filter(Boolean).join(' ');

  return {
    deptLine,
    nameLine,
    hasContent: !!(deptLine || nameLine),
  };
};
